// i18n.js
//import enUrl from 'raw:../locales/en.json';
//import esUrl from 'raw:../locales/es.json';

// const localeUrls = {
//   en: enUrl,
//   es: esUrl,
// };
const localeModules = {
  en: {
    common: () => import('../locales/en/common.json'),
    home: () => import('../locales/en/home.json'),
    health: () => import('../locales/en/health.json'),
    edu: () => import('../locales/en/edu.json'),
    hunger: () => import('../locales/en/hunger.json'),
    disasters: () => import('../locales/en/disasters.json'),
    animal: () => import('../locales/en/animal.json'),
    join: () => import('../locales/en/join.json'),
    auth: () => import('../locales/en/auth.json'),
    portal: () => import('../locales/en/portal.json'),
    club: () => import('../locales/en/club.json'),
  },
  es: {
    common: () => import('../locales/es/common.json'),
    home: () => import('../locales/es/home.json'),
    health: () => import('../locales/es/health.json'),
    edu: () => import('../locales/es/edu.json'),
    hunger: () => import('../locales/es/hunger.json'),
    disasters: () => import('../locales/es/disasters.json'),
    animal: () => import('../locales/es/animal.json'),
    join: () => import('../locales/es/join.json'),
    auth: () => import('../locales/es/auth.json'),
    portal: () => import('../locales/es/portal.json'),
    club: () => import('../locales/es/club.json'),
  },
};
export class Translator {
  constructor() {
    this.currentTranslations = {};
    this.currentLang = 'en';
    this.userData = {};

    // Define languages your application actually supports
    this.supportedLanguages = ['en', 'es'];
    this.defaultFallbackLanguage = 'en';

    // Toggle this to false in production to keep console clean
    this.debugMode = true;
  }

  setGlobalData(data) {
    this.userData = { ...this.userData, ...data };
  }

  // Define a map of URL keywords to specific page files
  getModulesForCurrentRoute() {
    const path = window.location.pathname;

    // Always load the 'common' module for global layouts (header/footer)
    const modules = ['common'];

    // Route matching rules
    if (
      path === '/' ||
      path.includes('index.html') ||
      path.includes('index2.html') ||
      path.includes('index2')
    ) {
      modules.push('home');
    } else if (path.includes('health')) {
      modules.push('health');
    } else if (path.includes('edu')) {
      modules.push('edu');
    } else if (path.includes('hunger')) {
      modules.push('hunger');
    } else if (path.includes('disasters')) {
      modules.push('disasters');
    } else if (path.includes('animals')) {
      modules.push('animal');
    } else if (path.includes('join')) {
      modules.push('join');
    } else if (path.includes('auth')) {
      modules.push('auth');
    } else if (path.includes('portal')) {
      modules.push('portal');
    } else if (
      window.__CURRENT_LAYOUT__ === 'club' ||
      path.includes('club') ||
      path.includes('piztio')
    ) {
      modules.push('club');
    }

    return modules;
  }

  // UPDATED: Core string replacement logic with built-in missing key detection
  t(key, elementData = {}) {
    // 1. Check if the key actually exists in our downloaded dictionary file
    if (!this.currentTranslations.hasOwnProperty(key)) {
      if (this.debugMode) {
        console.warn(
          `[i18n Warning]: Missing translation key "${key}" for language "${this.currentLang}"`,
        );
      }

      // Fallback strategy: return the key text cleanly formatted so the UI layout doesn't break
      // e.g., "missing_key_name" becomes "[missing_key_name]"
      return `[${key}]`;
    }

    let translation = this.currentTranslations[key];
    const combinedData = { ...this.userData, ...elementData };

    Object.keys(combinedData).forEach((placeholder) => {
      translation = translation.replaceAll(
        `{${placeholder}}`,
        combinedData[placeholder],
      );
    });

    return translation;
  }

  // NEW: Recursive deep scanner that bypasses Shadow DOM boundaries
  translatePage(targetNode = document.body) {
    // 1. If a selector string was passed (like '#greeting'), grab the actual DOM element
    if (typeof targetNode === 'string') {
      targetNode = document.querySelector(targetNode);
    }

    // 2. We extract your exact inner logic into a reusable worker function
    const processElement = (element) => {
      const textKey = element.getAttribute('data-i18n');
      const attrConfigStr = element.getAttribute('data-i18n-attr');
      const dataAttr = element.getAttribute('data-i18n-data');
      const elementData = dataAttr ? JSON.parse(dataAttr) : {};

      // Handle Standard Inner Text Content Translation
      if (textKey) {
        element.innerHTML = this.t(textKey, elementData);
      }

      // Handle Multiple Attribute Translations Dynamic Setup
      if (attrConfigStr) {
        try {
          const attrMapping = JSON.parse(attrConfigStr);
          Object.keys(attrMapping).forEach((targetHtmlAttr) => {
            const dictionaryKey = attrMapping[targetHtmlAttr];
            const translatedValue = this.t(dictionaryKey, elementData);
            // 1. Check if we already cached the original value from a previous language switch
            // const cacheKey = `data-i18n-orig-${targetHtmlAttr}`;
            // let originalValue = element.getAttribute(cacheKey);

            // if (originalValue === null) {

            //   originalValue = element.getAttribute(targetHtmlAttr) || '';

            //   element.setAttribute(cacheKey, originalValue);
            // }

            // const allowableFallbacks = ['', 'from-i18n', '#from-i18n'];

            // if (
            //   !originalValue ||
            //   allowableFallbacks.includes(originalValue.trim())
            // ) {
            //   element.setAttribute(targetHtmlAttr, translatedValue);
            // }
            element.setAttribute(targetHtmlAttr, translatedValue);
          });
        } catch (e) {
          if (textKey) {
            element.setAttribute(attrConfigStr, this.t(textKey, elementData));
          }
        }
      }
    };

    // 3. Your recursive crawl engine updated with targeted node matching capabilities
    const scanNode = (rootNode) => {
      if (!rootNode) return;

      // NEW CAPABILITY: If the targeted root element itself has an i18n attribute, translate it
      if (
        rootNode.hasAttribute?.('data-i18n') ||
        rootNode.hasAttribute?.('data-i18n-attr')
      ) {
        processElement(rootNode);
      }

      // Target any nested child elements matching your setup
      rootNode
        .querySelectorAll('[data-i18n], [data-i18n-attr]')
        .forEach((element) => {
          processElement(element);
        });

      // Deep crawl past any open component roots recursively
      rootNode.querySelectorAll('*').forEach((childElement) => {
        if (childElement.shadowRoot) {
          scanNode(childElement.shadowRoot);
        }
      });
    };

    // 4. Kick off the initial scan starting from your custom target node variable selection
    scanNode(targetNode);
  }

  async changeLanguage(lang, requiredModules = null) {
    try {
      // Fallback validation check
      if (!this.supportedLanguages.includes(lang)) {
        lang = this.defaultFallbackLanguage;
      }

      if (!requiredModules) {
        requiredModules = this.getModulesForCurrentRoute();
      }

      this.currentTranslations = {};

      // 2. Iterate through the requested modules using the static map
      const fetchPromises = requiredModules.map(async (moduleName) => {
        try {
          // Verify the requested language and module exist in our map
          const loadModuleFn = localeModules[lang]?.[moduleName];

          if (!loadModuleFn) {
            throw new Error(`Module handler not found`);
          }

          // Trigger the dynamic import function
          const moduleData = await loadModuleFn();

          // Merge the downloaded JSON file into active translation dictionary
          Object.assign(
            this.currentTranslations,
            moduleData.default || moduleData,
          );
        } catch (err) {
          console.error(
            `[i18n Error] Could not load chunk "${moduleName}" for language "${lang}"`,
            err,
          );
        }
      });

      await Promise.all(fetchPromises);

      this.currentLang = lang;
      this.translatePage();

      document.documentElement.lang = lang;
      localStorage.setItem('preferredLanguage', lang);

      const event = new CustomEvent('app:lang-changed', {
        detail: { language: lang },
      });
      window.dispatchEvent(event);
    } catch (error) {
      console.error('Translation Engine Error:', error);
    }
  }
  // NEW DETECT AND INITIALIZE SYSTEM
  init(dropdownId) {
    // 1. Check if user has an explicit manual save in localStorage
    const savedLang = localStorage.getItem('preferredLanguage');

    // 2. Read browser settings and isolate the first two letters (e.g., "en-US" -> "en")
    const browserLang = navigator.language.slice(0, 2);

    // 3. Determine target language: Saved Preference -> Browser Language -> Default Fallback
    let targetedLanguage = this.defaultFallbackLanguage;

    if (savedLang && this.supportedLanguages.includes(savedLang)) {
      targetedLanguage = savedLang;
    } else if (this.supportedLanguages.includes(browserLang)) {
      targetedLanguage = browserLang;
    }

    // 4. Update the visual dropdown selection state matching our decision
    const switcher = document.getElementById(dropdownId);
    if (switcher) {
      switcher.value = targetedLanguage;
      switcher.addEventListener('change', (e) =>
        this.changeLanguage(e.target.value),
      );
    }

    // 5. Fire up the translation dictionary pipeline
    this.changeLanguage(targetedLanguage);
  }

  initFromElement(switcherElement) {
    const savedLang = localStorage.getItem('preferredLanguage');
    const browserLang = navigator.language.slice(0, 2);
    let targetedLanguage = this.defaultFallbackLanguage;
    console.log('lang chosen: ', targetedLanguage);

    if (savedLang && this.supportedLanguages.includes(savedLang)) {
      targetedLanguage = savedLang;
    } else if (this.supportedLanguages.includes(browserLang)) {
      targetedLanguage = browserLang;
    }

    if (switcherElement) {
      switcherElement.value = targetedLanguage;
      switcherElement.addEventListener('change', (e) =>
        this.changeLanguage(e.target.value),
      );
    }

    this.changeLanguage(targetedLanguage);
  }
}

// Export a single shared instance of the translator
export const i18n = new Translator();
